import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getServiceAccountGiftCredits = async (email: string): Promise<number> => {
  const response = await queryExecute({
    query: graphql(`
      query GetServiceAccountGiftCredits($email: String!) {
        getServiceAccountGiftCredits(email: $email)
      }
    `),
    variables: {
      email,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getServiceAccountGiftCredits!;
};
